(() => { 'use strict'; const pushEvent = (eventName, element, extra = {}) => { if (!eventName || !window.dataLayer) return; const pageVersion = document.querySelector('[data-page-version]')?.dataset.pageVersion || 'academy-hub-v1'; window.dataLayer.push({ event: eventName, section: element.closest('[data-academy-section]')?.dataset.academySection || '', destination_url: element.getAttribute('href') || '', page_version: pageVersion, ...extra }); }; const initializeSizeReference = (section) => { const control = section.querySelector('[data-academy-size-control]'); const selector = section.querySelector('[data-academy-size-selector]'); const status = section.querySelector('[data-academy-size-status]'); const rows = Array.from(section.querySelectorAll('[data-academy-size-row]')); if (!control || !selector || rows.length === 0) return; const placements = new Map(); rows.forEach((row) => { const handle = row.dataset.placement; const label = row.querySelector('h3')?.textContent.trim(); if (handle && label && !placements.has(handle)) placements.set(handle, label); }); if (placements.size === 0) return; placements.forEach((label, handle) => { const option = document.createElement('option'); option.value = handle; option.textContent = label; selector.append(option); }); const showPlacement = (handle, announce = false) => { let visibleCount = 0; rows.forEach((row) => { const isVisible = row.dataset.placement === handle; row.hidden = !isVisible; if (isVisible) visibleCount += 1; }); if (announce && status) status.textContent = placements.get(handle) + ': ' + visibleCount + ' size ' + (visibleCount === 1 ? 'reference' : 'references') + ' shown.'; }; control.hidden = false; showPlacement(selector.value || placements.keys().next().value); selector.addEventListener('change', () => { showPlacement(selector.value, true); pushEvent('piercing_guide_size_tool_click', selector, { placement: selector.value }); }); }; document.querySelectorAll('[data-academy-section="size_quick_reference"]').forEach(initializeSizeReference); document.addEventListener('click', (event) => { const link = event.target.closest('a'); if (!link) return; if (link.matches('[data-academy-placement-link]')) pushEvent('piercing_guide_placement_open', link, { placement: link.closest('[data-academy-placement]')?.dataset.academyPlacement || '' }); else if (link.matches('[data-academy-certification-link]')) pushEvent('piercing_guide_certification_click', link); else if (link.matches('[data-academy-product-link]')) pushEvent('piercing_guide_product_click', link); else if (link.matches('[data-academy-size-link]')) pushEvent('piercing_guide_size_tool_click', link); else if (link.matches('[data-academy-nav-link], .academy-card__link')) pushEvent('piercing_guide_nav_click', link); }); })();
/* Placement/size explorer: server-rendered panels remain readable without JS. */
(() => {
  'use strict';
  if (window.academyExplorerLoaded) return;
  window.academyExplorerLoaded = true;
  const initialize = (root) => {
    root.querySelectorAll('[data-academy-explorer]').forEach((section) => {
      if (section.dataset.explorerReady) return;
      const panels = Array.from(section.querySelectorAll('[data-explorer-panel]'));
      const tablist = section.querySelector('[data-explorer-tabs]');
      const status = section.querySelector('[data-explorer-status]');
      if (!tablist || !panels.length) return;
      const buttons = panels.map((panel) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = panel.querySelector('h3').textContent.trim();
        button.id = panel.id + '-tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panel.id);
        tablist.append(button);
        return button;
      });
      const select = (index, announce = false) => {
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          buttons[i].setAttribute('aria-selected', String(i === index));
          buttons[i].tabIndex = i === index ? 0 : -1;
        });
        if (announce && status) status.textContent = buttons[index].textContent + ' fit references shown.';
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index, true));
        button.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault();
          buttons[next].focus();
          select(next, true);
        });
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', button.id);
        panels[index].tabIndex = 0;
      });
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Choose a piercing');
      select(0);
      tablist.hidden = false;
      section.dataset.explorerReady = 'true';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

/* FAQ category enhancement. Every group and answer is present in server HTML. */
(() => {
  'use strict';
  if (window.academyFaqLoaded) return;
  window.academyFaqLoaded = true;
  const initialize = (root) => {
    root.querySelectorAll('[data-academy-faq]').forEach((section) => {
      if (section.dataset.faqReady) return;
      const links = Array.from(section.querySelectorAll('[data-faq-filter]'));
      const groups = Array.from(section.querySelectorAll('[data-faq-topic]'));
      const status = section.querySelector('[data-faq-status]');
      if (!links.length || !groups.length) return;
      const select = (link, announce = false) => {
        const topic = link.dataset.faqFilter;
        groups.forEach((group) => { group.hidden = topic !== 'all' && group.dataset.faqTopic !== topic; });
        links.forEach((item) => {
          if (item === link) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        if (announce && status) status.textContent = link.textContent.trim() + ' shown.';
      };
      links.forEach((link, index) => {
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          select(link, true);
        });
        link.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % links.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + links.length) % links.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = links.length - 1;
          else return;
          event.preventDefault();
          links[next].focus();
          select(links[next], true);
        });
      });
      select(links[0]);
      section.dataset.faqReady = 'true';
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
